export default __webpack_public_path__ + "media/images/24-776e9c6408a0c7e3dcbd57f76a37fd0c.jpg";